import type { Decamelized } from 'humps';

import type { CreateSessionPayload } from '../sessions';

type CreateMapper = {
  mapToBackend: (
    params: CreateSessionPayload,
  ) => Decamelized<CreateSessionPayload>;
};
export const createMapper: CreateMapper = {
  mapToBackend: params => {
    validatePayload(params);
    const {
      paymentMethodToken,
      sessionType,
      mandateAch,
      orderId,
      orderToken,
      recurringReceivableId,
      consumerSessionId,
      captchaResponse,
    } = params;
    return {
      payment_method_token: paymentMethodToken,
      session_type: sessionType,
      mandate_ach: mandateAch
        ? {
            init_date: mandateAch.initDate,
            final_date: mandateAch.finalDate,
            number_of_payments: mandateAch.numberOfPayments,
          }
        : undefined,
      order_id: orderId,
      order_token: orderToken,
      recurring_receivable_id: recurringReceivableId,
      consumer_session_id: consumerSessionId,
      captcha_response: captchaResponse,
    };
  },
};

const validatePayload = (params: CreateSessionPayload) => {
  if (!params.sessionType) {
    throw new Error('Session type is required');
  }
  if (params.sessionType === 'card_tokenization_for_one_off') {
    return;
  }
  if (params.sessionType === 'new_mandate' && !params.paymentMethodToken) {
    throw new Error('paymentMethodToken is required for this session type');
  }

  if (!(params.orderId && params.orderToken) && !params.recurringReceivableId) {
    throw new Error(
      'Either order or recurring identification params are required',
    );
  }
};
